// @ts-ignore
let $ = window.jQuery;

const $header = $(`<div class="gf-batch-menu"><div>${PDFGenerator.text_batch_actions}<span class="gf-pdf-batch-count"></span></div></div>`);
const $footer = $header.clone();

const queue: JQuery[] = [];
let isSetup = false;


export function disableButtons() {
    $header.find('button').prop('disabled', true);
    $footer.find('button').prop('disabled', true);
}

export function enableButtons() {
    $header.find('button').prop('disabled', false);
    $footer.find('button').prop('disabled', false);
}

export function addBatchItem(item: JQuery) {
    if (!isSetup) {
        queue.push(item);
        return;
    }

    $header.append(item);
    $footer.append(item.clone());
}

function countSelectedEntries() {
    const count = $('input[name="entries[]"]:checked').length;
    const selectedCount = PDFGenerator.text_batch_selected_count.replace('##', count.toString());
    $header.find('.gf-pdf-batch-count').text(selectedCount);
    $footer.find('.gf-pdf-batch-count').text(selectedCount);
}

export function setupBatchMenu() {
    $('.gv-container').append($header).prepend($footer);

    isSetup = true;

    if (queue.length) {
        queue.forEach((item) => {
            addBatchItem(item);
        });
    }

    countSelectedEntries();

    $('body').on('change', 'input[name="entries[]"]', countSelectedEntries)
        .on('gv_datatables_reloaded', countSelectedEntries);
}